import React from 'react';
import './LearningPartner.css';

const LearningPartner = () => {
  return (
    <section className="lp-section">
      <p className="lp-label">Academic, Training &amp; Placement Partners</p>
      <div className="lp-wrapper">
        <div className="lp-cards-grid">

          {/* Imarticus */}
          <div className="lp-card">
            <div className="lp-badge">Academic &amp; Placement Partner</div>
            <div className="lp-logo-wrap">
              <img src="/partners/Imarticus.webp" alt="Imarticus Learning" className="lp-logo" />
            </div>
            <div className="lp-divider" />
            <div className="lp-content">
              <div className="lp-info">
                <span className="lp-name">Imarticus Learning</span>
                <span className="lp-tagline">
                  India's Leading Finance, Business, Technology &amp; Analytics Institute
                </span>
              </div>
              <a
                href="https://imarticus.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="lp-visit-btn"
              >
                <span>Visit Website</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>

          {/* NSDC */}
          <div className="lp-card">
            <div className="lp-badge lp-badge--green">Skill Development Partner</div>
            <div className="lp-logo-wrap">
              <img src="/partners/nsdc.webp" alt="National Skill Development Corporation" className="lp-logo" />
            </div>
            <div className="lp-divider" />
            <div className="lp-content">
              <div className="lp-info">
                <span className="lp-name">NSDC</span>
                <span className="lp-tagline">
                  National Skill Development Corporation — Government of India Initiative
                </span>
              </div>
              <a
                href="https://nsdcindia.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="lp-visit-btn lp-visit-btn--green"
              >
                <span>Visit Website</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default LearningPartner;
